var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeedMoreData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 95,
    viewBox: "0 0 132 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 130,
    height: 92,
    rx: 5,
    stroke: "#4B43FF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7227,
    y: 80.9434,
    width: 20.3569,
    height: 4.01768,
    rx: 2,
    fill: "#E0DFF8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.2227,
    y: 78.9346,
    width: 20.3569,
    height: 6.02652,
    rx: 2,
    fill: "#E0DFF8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7227,
    y: 81.9482,
    width: 20.3569,
    height: 3.01326,
    rx: 1.50663,
    fill: "#E0DFF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.2227,
    y: 82.9521,
    width: 20.3569,
    height: 2.00884,
    rx: 1.00442,
    fill: "#E0DFF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedMoreData);
export default __webpack_public_path__ + "static/media/need_more_data.948bd532ee53fa01dc180c33e2aca1c4.svg";
export { ForwardRef as ReactComponent };